import { render, staticRenderFns } from "./SemPermissao.vue?vue&type=template&id=5e7147d6&scoped=true"
import script from "./SemPermissao.vue?vue&type=script&lang=js"
export * from "./SemPermissao.vue?vue&type=script&lang=js"
import style0 from "./SemPermissao.vue?vue&type=style&index=0&id=5e7147d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7147d6",
  null
  
)

export default component.exports